var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBook = function SvgBook(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 22",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.667 1.833c-1.013 0-1.834.821-1.834 1.834v11.49a3.65 3.65 0 0 1 1.834-.49H16.5V1.833H3.667ZM16.5 16.5H3.667a1.833 1.833 0 0 0 0 3.667H16.5V16.5ZM0 18.334V3.667A3.667 3.667 0 0 1 3.667 0h13.75l.916.917V22H3.667A3.667 3.667 0 0 1 0 18.334Z",
    clipRule: "evenodd"
  })));
};
export default SvgBook;